import React from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import ContentLayoutFooterNoChartreuse from "../components/Layout/ContentLayoutFooterNoChartreuse";

const DiscoverComponent = dynamic(() => import("../components/Discover"));

function Discover() {
  const router = useRouter();
  const queryString = router.asPath.split("?")[1];
  const queryParams = new URLSearchParams(queryString);
  const id = queryParams.get("id");

  return (
    <ContentLayoutFooterNoChartreuse title="Discover">
      <DiscoverComponent id={id} />
    </ContentLayoutFooterNoChartreuse>
  );
}

export default Discover;

export async function getStaticProps() {
  return {
    props: { page: "Discover" },
  };
}
